<mat-toolbar class="dashboard-titlebar">Admin Dashboard</mat-toolbar>

<div class="dashboard-root page-shell">
  <div class="dashboard-container">
    <section class="metrics-grid" aria-label="Dashboard metrics">
      <mat-card>
        <mat-card-title>Organizations</mat-card-title>
        <mat-card-content class="metric">
          <div class="metric-value">{{ metrics().orgs }}</div>
          <div class="metric-label">Total orgs</div>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-title>Accounts</mat-card-title>
        <mat-card-content class="metric">
          <div class="metric-value">{{ metrics().accounts }}</div>
          <div class="metric-label">Active company accounts</div>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-title>Users</mat-card-title>
        <mat-card-content class="metric">
          <div class="metric-value">{{ metrics().users }}</div>
          <div class="metric-label">Users provisioned</div>
        </mat-card-content>
      </mat-card>
    </section>

    <section class="quick-actions" aria-label="Quick actions">
      <button mat-flat-button color="primary" routerLink="/organizations">
        Manage organizations
      </button>
      <button mat-stroked-button routerLink="/accounts">Create account</button>
      <button mat-stroked-button routerLink="/users">Create user</button>
    </section>

    <section class="org-table">
      <div class="table-header">
        <h2>Organizations</h2>
        <button mat-flat-button color="primary" (click)="load()">Refresh</button>
      </div>

      @if (loading()) {
        <div class="loading">
          <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        </div>
      } @else {
        <table mat-table [dataSource]="orgs()" class="mat-elevation-z1">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let el">{{ el.name }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let el">{{ el.status }}</td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let el">{{ format(el.createdAt) }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let el">
              <a
                mat-button
                color="primary"
                routerLink="/accounts"
                [queryParams]="{ organizationId: el._id }"
                >Add account</a
              >
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </section>
  </div>
</div>
